import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import {
  Paper, Table, TableBody, TableCell, TableHead, TableRow,
} from '@material-ui/core';
import TableHeader from '../../../models/TableHeader';
import TooltipUI from '../../../components/UI/Tooltip/Tooltip';
import Grid24 from '../../../components/UI/Grid24';
import { getMoneyMask, useUtilStyles } from '../../../helpers';
import useStyles from './TabelaRendimentoMensalNegociador.style';
import { rendimentoMensalNegociadorFactory } from './RendimentoMensalNegociadorFactory';

function TabelaRendimentoMensalNegociador({
  content, dataBase,
}) {
  const utilStyles = useUtilStyles();
  const styles = useStyles();
  const data = rendimentoMensalNegociadorFactory.makeHeaderGraficoRendimentoMensalNegociador(content, dataBase);

  const [columns] = useState([
    new TableHeader({
      id: 'nomeFilial', label: 'Filial', alignCell: 'center',
    }),
    new TableHeader({
      id: 'nomeLogin', label: 'Negociador', alignCell: 'center',
    }),
    new TableHeader({
      id: 'saldo1', label: 'Saldo 1', minWidth: 'auto', alignCell: 'center',
    }),

    new TableHeader({
      id: 'saldo2', label: 'Saldo 2', minWidth: 'auto', alignCell: 'center',
    }),
    new TableHeader({
      id: 'saldo3', label: 'Saldo 3', minWidth: 'auto', alignCell: 'center',
    }),
    new TableHeader({
      id: 'saldo4', label: 'Saldo 4', minWidth: 'auto', alignCell: 'center',
    }),
    new TableHeader({
      id: 'saldo5', label: 'Saldo 5', minWidth: 'auto', alignCell: 'center',
    }),
    new TableHeader({
      id: 'saldo6', label: 'Saldo 6', minWidth: 'auto', alignCell: 'center',
    }),
    new TableHeader({
      id: 'saldo7', label: 'Saldo 7', minWidth: 'auto', alignCell: 'center',
    }),
    new TableHeader({
      id: 'saldo8', label: 'Saldo 8', minWidth: 'auto', alignCell: 'center',
    }),
    new TableHeader({
      id: 'saldo9', label: 'Saldo 9', minWidth: 'auto', alignCell: 'center',
    }),
    new TableHeader({
      id: 'saldo10', label: 'Saldo 10', minWidth: 'auto', alignCell: 'center',
    }),
    new TableHeader({
      id: 'saldo11', label: 'Saldo 11', minWidth: 'auto', alignCell: 'center',
    }),
    new TableHeader({
      id: 'saldo12', label: 'Saldo 12', minWidth: 'auto', alignCell: 'center',
    }),
  ]);

  const rows = content?.map(item => ({
    id: item.codUsuario,
    values: {
      nomeFilial: item.nomeFilial,
      nomeLogin: item.nomeLogin,
      saldo1: getMoneyMask(item.saldo1 === null ? 0 : item.saldo1),
      saldo2: getMoneyMask(item.saldo2 === null ? 0 : item.saldo2),
      saldo3: getMoneyMask(item.saldo3 === null ? 0 : item.saldo3),
      saldo4: getMoneyMask(item.saldo4 === null ? 0 : item.saldo4),
      saldo5: getMoneyMask(item.saldo5 === null ? 0 : item.saldo5),
      saldo6: getMoneyMask(item.saldo6 === null ? 0 : item.saldo6),
      saldo7: getMoneyMask(item.saldo7 === null ? 0 : item.saldo7),
      saldo8: getMoneyMask(item.saldo8 === null ? 0 : item.saldo8),
      saldo9: getMoneyMask(item.saldo9 === null ? 0 : item.saldo9),
      saldo10: getMoneyMask(item.saldo10 === null ? 0 : item.saldo10),
      saldo11: getMoneyMask(item.saldo11 === null ? 0 : item.saldo11),
      saldo12: getMoneyMask(item.saldo12 === null ? 0 : item.saldo12),
    },
  }));

  function getLabelHeader(index) {
    if (index === 0) {
      return (columns[index].label);
    }

    const item = data[index - 2];
    return item ? item.data : columns[index].label;
  }

  const getContent = (value, column) => {
    if (column.showTip) {
      return (
        <TooltipUI title={value} placement="bottom-start" interactive>
          <div className={styles.fitContent}>
            <pre
              className={styles.overFlowText}
              style={{ maxWidth: column.maxWidth - 16 }}
            >
              {column.format && typeof value === 'number' ? column.format(value) : value}
            </pre>
          </div>
        </TooltipUI>
      );
    }
    return (
      <pre>
        {column.format && typeof value === 'number' ? column.format(value) : value}
      </pre>
    );
  };

  const buildTableRow = row => (
    <TableRow>
      {columns.map((column) => {
        const value = row.values[column.id];
        return (
          <TableCell
            key={column.id}
            align={column.alignCell}
            style={{ textAlign: value === '-' ? 'center' : 'auto' }}
          >
            {getContent(value, column)}
          </TableCell>
        );
      })}
    </TableRow>
  );

  return (
    <>
      <Grid24 container isFormContainer spacing={1} className={utilStyles.mt16}>
        <Grid24 item xs={24} sm={24}>
          <Paper className={styles.wrapper}>
            <Table
              stickyHeader
              size="medium"
            >
              <TableHead>
                <TableRow>
                  {columns.map((column, index) => (
                    <TableCell
                      id={column.id}
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                    >
                      {getLabelHeader(index)}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows?.map(row => buildTableRow(row))}
              </TableBody>
            </Table>
          </Paper>
        </Grid24>
      </Grid24>
    </>
  );
}

export default withRouter(TabelaRendimentoMensalNegociador);
